if not App.angularApp?
    return

# Validates that date is in one of two formats: dd/mm/yyyy and d/m/yyyy

DATE_REGEXP = /^(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/(199\d|[2-9]\d{3})$/

App.angularApp.directive 'mfIsDatePickerFormat', () ->
    return {
        require: 'ngModel'
        link: (scope, element, attrs, ngModel) =>
            ngModel.$validators.mfIsDatePickerFormat = (modelValue, viewValue) =>
                if ngModel.$isEmpty(modelValue)
                    return true

                if DATE_REGEXP.test(viewValue)
                    return true

                return false
    }
